var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":"Analyses","active":""}},[_c('h3',[_vm._v("Analyses")]),_c('analysis-server-table',{attrs:{"instance_instrument_id":_vm.instrument_id,"show_columns":[
          'name',
          'modus_name',
          'extraction_method',
          'measurement_method'
        ]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }